"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importStar(require("styled-components"));
var DynamicIcon_1 = require("../DynamicIcon");
var types_1 = require("./types");
var styles_1 = __importStar(require("./styles"));
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  > span {\n    display: flex;\n  }\n\n  ", ";\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  > span {\n    display: flex;\n  }\n\n  ", ";\n"])), styles_1.buttonReset, styles_1.linkReset, styles_1.default, styles_1.getIconButtonSize, function (_a) {
    var loading = _a.loading;
    return (Boolean(loading) ? 'pointer-events: none;' : undefined);
});
/**
 * Our standard icon button component. Can also function as a link via usage of the `to` prop.
 */
var IconButton = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'secondary' : _b, _c = _a.backdrop, backdrop = _c === void 0 ? 'onLight' : _c, _d = _a.size, size = _d === void 0 ? types_1.ButtonSize.large : _d, icon = _a.icon, disabled = _a.disabled, ariaLabel = _a.ariaLabel, loading = _a.loading, props = __rest(_a, ["variant", "backdrop", "size", "icon", "disabled", "ariaLabel", "loading"]);
    var theme = (0, styled_components_1.useTheme)();
    var variantStyles;
    if (backdrop === 'onLight') {
        variantStyles = disabled
            ? theme.button[variant].disabled
            : theme.button[variant].default;
    }
    else {
        variantStyles = disabled
            ? theme.button[variant].onDark.disabled
            : theme.button[variant].onDark.default;
    }
    return (react_1.default.createElement(Button, __assign({ as: props.to ? react_router_dom_1.Link : 'button', "aria-live": loading ? 'polite' : 'off', "aria-label": loading ? 'Loading' : ariaLabel, "$loading": loading, disabled: disabled, "aria-disabled": disabled, "$variantStyles": variantStyles, size: size }, props),
        react_1.default.createElement(DynamicIcon_1.DynamicIcon, { Icon: icon, primaryColor: variantStyles.textColor })));
};
exports.IconButton = IconButton;
var templateObject_1;
